export enum StructureStatus {
	LOGICAL_IN_PROGRESS = 'logical_in_progress',
	LOGICAL_COMPLETED = 'logical_completed',
	PHYSICAL_IN_PROGRESS = 'physical_in_progress',
	PHYSICAL_COMPLETED = 'physical_completed',
	FROZEN = 'frozen',
}
